import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}],["path",{"d":"M3 10h18","key":"svg-1"}],["path",{"d":"M10 3v18","key":"svg-2"}]]

const IconTableDashed = createReactComponent('outline', 'table-dashed', 'TableDashed', __iconNode);

export default IconTableDashed;